export default function TestimonialSection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[480px] bg-background-50">
      <div className="flex-1 flex items-center px-8 md:px-16 py-14">
        <div className="max-w-xl">
          <div className="flex items-center gap-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-foreground-900"></span>
            <span className="text-xs font-medium text-foreground-600 tracking-widest uppercase">
              Recensioni Verificate
            </span>
          </div>
          <blockquote className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug mb-6">
            <span className="text-5xl md:text-6xl text-primary-400 leading-none">&ldquo;</span>
            <br />
            Itaobuy Spreadsheet ha<br />
            rivoluzionato il mio modo<br />
            di fare shopping online
          </blockquote>
          <div className="flex items-center gap-3">
            <span className="text-sm font-semibold text-foreground-900">Marco R.</span>
            <span className="inline-flex items-center gap-1 text-xs text-accent-600">
              <i className="ri-checkbox-circle-fill text-accent-500"></i>
              Verificato su Trustpilot
            </span>
          </div>
        </div>
      </div>

      <div className="flex-1 relative overflow-hidden min-h-[360px]">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20black%20and%20white%20editorial%20portrait%20of%20confident%20Italian%20woman%20in%20profile%2C%20soft%20dramatic%20side%20lighting%2C%20clean%20light%20grey%20studio%20background%2C%20minimal%20sophisticated%20fashion%20photography%2C%20timeless%20aesthetic%2C%20high%20contrast%20with%20gentle%20shadow%20gradient%2C%20artistic%20composition&width=900&height=1100&seq=testimonial-portrait-v2&orientation=portrait"
          alt="Cliente soddisfatto"
          title="Itaobuy Spreadsheet - Recensioni"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </section>
  );
}